export enum RolesEnum {
  CLIENT = 'CLIENT',
  PARTNER = 'PARTNER'
}
